import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IFedopsLoggerDefinition } from '@wix/viewer-service-fedops-logger/definition'
import { FedopsLoggerDefinition as definition } from '@wix/viewer-service-fedops-logger/definition'
import { FedopsLoggerService as impl } from '@wix/viewer-service-fedops-logger/implementations'

export const fedopsLoggerService: FactoryWithDependencies<ServiceProvider<IFedopsLoggerDefinition, typeof impl>> =
	withDependencies([], (): ServiceProvider<IFedopsLoggerDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: {},
			platformConfig: {},
		}
	})
